import { useState } from "react";
import { collection, addDoc, query, where, getDocs } from "firebase/firestore";
import { db } from "../firebase";

export default function MemberRegistration() {
  const [name, setName] = useState("");
  const [mobile, setMobile] = useState("");
  const [photo, setPhoto] = useState(null);
  const [signature, setSignature] = useState(null);

  const [memberId, setMemberId] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  // 🔐 Auto Generate
  const generateMemberId = () =>
    "SMB" + Math.floor(100000 + Math.random() * 900000);

  const generatePassword = () =>
    Math.random().toString(36).slice(-8);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!name || !mobile) {
      alert("Name and Mobile are required");
      return;
    }

    setLoading(true);

    try {
      // ❌ Duplicate Mobile Check
      const q = query(
        collection(db, "members"),
        where("mobile", "==", mobile)
      );
      const snapshot = await getDocs(q);

      if (!snapshot.empty) {
        alert("This mobile number is already registered");
        setLoading(false);
        return;
      }

      // ✅ Generate values
      const newMemberId = generateMemberId();
      const newPassword = generatePassword();
      const voucherId = "TXN" + Date.now();

      // ✅ Save to Firestore
      await addDoc(collection(db, "members"), {
        memberId: newMemberId,
        name,
        mobile,
        password: newPassword,
        createdBy: "Admin",
        createdAt: new Date().toLocaleString(),
        voucherId,
        photo: "",
        signature: "",
      });

      // ✅ Show credentials
      setMemberId(newMemberId);
      setPassword(newPassword);

      // Reset form
      setName("");
      setMobile("");
      setPhoto(null);
      setSignature(null);
    } catch (error) {
      console.error(error);
      alert("Something went wrong");
    }

    setLoading(false);
  };

  return (
    <div className="card">
      <div className="card-body">

        {/* 🔍 SEARCH BAR */}
        <input
          className="form-control mb-3"
          placeholder="Search Member by Name / Mobile / Member ID"
        />

        <h5 className="mb-3">Member Registration</h5>

        <form onSubmit={handleSubmit}>
          <div className="row">

            <div className="col-md-6 mb-3">
              <label>Member Name</label>
              <input
                className="form-control"
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
            </div>

            <div className="col-md-6 mb-3">
              <label>Mobile Number</label>
              <input
                className="form-control"
                value={mobile}
                onChange={(e) => setMobile(e.target.value)}
              />
            </div>

            <div className="col-md-6 mb-3">
              <label>Photo (Optional)</label>
              <input
                type="file"
                className="form-control"
                onChange={(e) => setPhoto(e.target.files[0])}
              />
            </div>

            <div className="col-md-6 mb-3">
              <label>Signature (Optional)</label>
              <input
                type="file"
                className="form-control"
                onChange={(e) => setSignature(e.target.files[0])}
              />
            </div>
          </div>

          <button
            className="btn btn-primary mt-2"
            disabled={loading}
          >
            {loading ? "Registering..." : "Register Member"}
          </button>
        </form>

        {/* 🔐 GENERATED CREDENTIALS */}
        {memberId && (
          <div className="alert alert-success mt-4">
            <strong>Member Created Successfully</strong>
            <br />
            <b>Member ID:</b> {memberId}
            <br />
            <b>Password:</b> {password}
          </div>
        )}
      </div>
    </div>
  );
}